import { AllowanceModelDto } from '@zorro/clients';
import { DocumentCard } from '@zorro/design-system/v2/DocumentCard';
import { formatToMMMDayYear } from '@zorro/shared/formatters';

import { exportAllowanceModelToCsv } from '../PlanYearSetupForm/PlanYearSetupUtils';
import { UploadedFileBox } from '../UploadedFileBox';

type AllowanceModelManagementProps = {
  allowanceModel?: File | AllowanceModelDto;
  isRequired?: boolean;
  onClickDelete: () => void;
  sourceLabel?: string | null;
};

const AllowanceModelManagement = ({
  allowanceModel,
  isRequired = true,
  onClickDelete,
  sourceLabel,
}: AllowanceModelManagementProps) => {
  if (!allowanceModel) {
    return null;
  }

  if (allowanceModel instanceof File) {
    return (
      <UploadedFileBox
        onClickDelete={onClickDelete}
        label="Allowance Model"
        isRequired={isRequired}
        name={allowanceModel.name}
      />
    );
  }

  // A stored model has no file behind it — it is exported to CSV on demand.
  return (
    <DocumentCard
      fileName={`Existing ${allowanceModel.year} allowance model`}
      description={sourceLabel ?? undefined}
      date={`Uploaded ${formatToMMMDayYear(allowanceModel.updatedAt)}`}
      onDownload={() => exportAllowanceModelToCsv(allowanceModel)}
      onDelete={onClickDelete}
      deleteLabel="Remove"
    />
  );
};

export { AllowanceModelManagement };
